import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'When this system confirmed this fact.',
    isOptional: false,
    name: 'Observed At',
    partialId: PartialId.Standard.create('observed_at'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
